// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dp__week_num{color:#7eaae3;font-size:small}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Proposal/Show/ProposalProgram.vue"],"names":[],"mappings":"AACA,cAEE,aAAA,CADA,eACA","sourcesContent":["\n.dp__week_num {\n  font-size: small;\n  color: #7eaae3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
